module.exports = __webpack_public_path__ + "img/SWP_Shield_02 (1).88405c79.png";